import styled from '@emotion/styled';
import { Button, Drawer, Input, Modal, Table, Tag } from 'antd';
import { ReactNode, useEffect, useState } from 'react';
import { FaBoxOpen, FaCoins, FaCrown, FaExclamationTriangle, FaPlus, FaRegClock, FaTrash } from 'react-icons/fa';
import { FiSearch } from 'react-icons/fi';
import { MdClose } from 'react-icons/md';
import { PackType } from '../../../../redux/userStore/reducer';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { deletePack, getPack } from '../../../dashboard/network';
import { Layout } from '../../../shared/Layout';
import { PackForm } from '../components/PackForm';
import { PackUpdateForm } from '../components/PackUpdateForm';

const Container = styled.div`
  min-height: calc(100vh - 76px);
  background:
    radial-gradient(circle at 8% 0%, rgba(255, 79, 31, 0.08), transparent 24%),
    radial-gradient(circle at 92% 8%, rgba(255, 176, 0, 0.08), transparent 22%),
    var(--mt-bg);
  color: var(--mt-text);
  font-family: Poppins-R;

  .bread-crum span {
    color: var(--mt-text);
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: #fff7e8 !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: var(--mt-row-odd);
    color: var(--mt-text);
  }

  .even-row {
    background-color: var(--mt-row-even);
    color: var(--mt-text);
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: var(--mt-row-hover) !important;
      cursor: pointer;
      color: var(--mt-text);
    }
  }

  .content {
    padding: 12px;
    width: 100%;
    background: transparent;
    color: var(--mt-text);
  }

  .admin-hero {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 18px;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.13), transparent 38%),
      ${PRIMARY};
    box-shadow: var(--mt-card-shadow);
  }

  .eyebrow {
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .admin-hero h1 {
    margin: 6px 0 0;
    color: #fff7e8;
    font-family: Poppins-B;
    font-size: 30px;
  }

  .admin-hero p {
    max-width: 760px;
    margin: 8px 0 0;
    color: rgba(255, 247, 232, 0.72);
  }

  .primary-action {
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, ${YELLOW});
    color: #07141c;
    font-family: Poppins-B;
  }

  .pack-highlight {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid rgba(255, 176, 0, 0.28);
    border-radius: 8px;
    padding: 12px;
    color: #fff7e8;
    background: rgba(255, 255, 255, 0.06);
    font-family: Poppins-B;
  }

  .kpi-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    margin-top: 12px;
  }

  .kpi-card,
  .page-toolbar,
  .table-shell {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    background: var(--mt-card);
    box-shadow: var(--mt-card-shadow);
  }

  .kpi-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 78px;
    padding: 13px;
  }

  .kpi-card .label {
    color: var(--mt-muted);
    font-size: 11px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .kpi-card .value {
    display: block;
    margin-top: 5px;
    color: var(--mt-text);
    font-family: Poppins-B;
    font-size: 22px;
  }

  .kpi-card .icon {
    color: var(--mt-warning);
  }

  .page-toolbar {
    display: grid;
    grid-template-columns: minmax(260px, 360px) 1fr auto;
    align-items: center;
    gap: 12px;
    margin: 12px 0;
    padding: 12px;
  }

  .search-box {
    position: relative;
  }

  .search-box svg {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 11px;
    color: var(--mt-muted);
    transform: translateY(-50%);
  }

  .search-box .ant-input {
    height: 38px;
    border-color: var(--mt-border);
    border-radius: 999px;
    padding-left: 34px;
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .table-shell {
    overflow: hidden;
    padding: 12px;
  }

  .pack-cell strong {
    display: block;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .pack-cell span {
    color: var(--mt-muted);
    font-size: 11px;
  }

  .amount-cell {
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .duration-tag {
    border-radius: 999px;
    color: ${YELLOW};
    background: rgba(255, 176, 0, 0.12);
    border-color: rgba(255, 176, 0, 0.28);
    font-family: Poppins-B;
  }

  .danger-action {
    min-width: 160px;
    height: 40px;
    border: 1px solid rgba(255, 59, 48, 0.35);
    border-radius: 999px;
    background: rgba(255, 59, 48, 0.08);
    color: #ff3b30;
    font-family: Poppins-B;
  }

  .delete-modal .ant-modal-content {
    border-radius: 8px;
    background: var(--mt-card);
    color: var(--mt-text);
  }

  .delete-warning {
    display: flex;
    gap: 14px;
    border: 1px solid rgba(255, 59, 48, 0.24);
    border-radius: 8px;
    padding: 14px;
    background: rgba(255, 59, 48, 0.07);
  }

  .delete-warning svg {
    color: #ff3b30;
  }

  .delete-warning strong {
    display: block;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .delete-warning p {
    margin: 6px 0 0;
    color: var(--mt-muted);
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
  }

  .modal-cancel,
  .modal-delete {
    min-width: 120px;
    height: 40px;
    border-radius: 999px;
    font-family: Poppins-B;
  }

  .modal-cancel {
    border: 1px solid var(--mt-border);
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .modal-delete {
    border: 0;
    background: #ff3b30;
    color: #fff;
  }

  @media (max-width: 760px) {
    .content {
      padding: 18px 12px;
    }

    .admin-hero,
    .page-toolbar {
      grid-template-columns: 1fr;
      flex-direction: column;
      align-items: flex-start;
    }

    .kpi-grid {
      grid-template-columns: 1fr;
    }
  }
`;

export const PackPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showDrawer1, setShowDrawer1] = useState(false);
  const [pack, setPack] = useState<PackType[]>([]);
  const [filterPack, setFilterPack] = useState<PackType[]>([]);
  const [selectedPack, setSelectedPack] = useState<PackType>({
    id: '0',
    nom: 'OK',
    amount: 0,
    duree_an: 0,
    created_at: 'string',
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const fetchData = () => {
    getPack().then(({ data }) => {
      setPack(data);
      setFilterPack(data);
      setIsLoading(false);
    });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const suppPack = () => {
    setIsLoading(true);
    if (selectedPack) {
      deletePack(selectedPack.id).then(() => {
        setIsLoading(false);
        setShowDeleteModal(false);
        fetchData();
      });
    }
  };
  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <div style={{ marginTop: 0 }}>
            <section className='admin-hero'>
              <div>
                <span className='eyebrow'>Administration</span>
                <h1>Packs et abonnements</h1>
                <p>
                  Configurez les offres commerciales, montants et durées
                  d’accès à la plateforme.
                </p>
              </div>
              <div className='pack-highlight'>
                <FaCrown />
                Catalogue commercial
              </div>
              <Button icon={<FaPlus />} className='primary-action' onClick={() => setShowDrawer(true)}>
                Nouveau pack
              </Button>
            </section>

            <section className='kpi-grid'>
              <KpiCard label='Packs actifs' value={filterPack.length || '--'} icon={<FaBoxOpen />} />
              <KpiCard label='Montant moyen' value={filterPack.length ? Math.round(filterPack.reduce((sum, p) => sum + Number(p.amount || 0), 0) / filterPack.length) : '--'} icon={<FaCoins />} />
              <KpiCard label='Durée moyenne' value={filterPack.length ? `${Math.round(filterPack.reduce((sum, p) => sum + Number(p.duree_an || 0), 0) / filterPack.length)} an` : '--'} icon={<FaRegClock />} />
            </section>

            <div className='page-toolbar'>
              <div className='search-box'>
                <FiSearch />
              <Input
                placeholder='Rechercher...'
                onChange={(e) => {
                  setFilterPack(
                    pack.filter((p) =>
                      p.nom
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase()),
                    ),
                  );
                }}
              />
              </div>
              <span />
            </div>

            <div className='table-shell'>
            <Table
              columns={COLUMNS}
              dataSource={filterPack}
              rowClassName={(row, index) =>
                index % 2 === 0 ? 'even-row' : 'odd-row'
              }
              size='small'
              loading={isLoading}
              style={{ zoom: 0.9 }}
              scroll={{ x: 640 }}
              pagination={false}
              onRow={(row, rowIndex) => {
                return {
                  onClick: (event) => {
                    setSelectedPack(row);
                    console.log(selectedPack);
                    setShowDrawer1(true);
                  }, // click row
                  onDoubleClick: (event) => {}, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
            </div>
          </div>
        </div>
        <Drawer
          title='Ajouter un pack'
          placement='right'
          width='min(100vw, 520px)'
          onClose={() => setShowDrawer(false)}
          open={showDrawer}
          closeIcon={<MdClose size={20} />}
        >
          <PackForm
            setShowDrawer={setShowDrawer}
            getNewPack={(part) => {
              setPack([...pack, part]);
              setFilterPack([...filterPack, part]);
            }}
          />
        </Drawer>
        <Drawer
          title='Modifier un pack'
          placement='right'
          width='min(100vw, 520px)'
          onClose={() => setShowDrawer1(false)}
          open={showDrawer1}
          closeIcon={<MdClose size={20} />}
        >
          <PackUpdateForm
            setShowDrawer={setShowDrawer1}
            setthepack={selectedPack}
            getNewPack={(pack) => {
              setPack(pack);
              setFilterPack(pack);
            }}
          />
          <Button
            icon={<FaTrash style={{ marginBottom: -2, marginRight: 5 }} />}
            className='danger-action'
            loading={isLoading}
            onClick={() => {
              setShowDeleteModal(true);
              setShowDrawer1(false);
            }}
          >
            Supprimer
          </Button>
        </Drawer>
        <Modal
          open={showDeleteModal}
          title='Supprimer le pack'
          className='delete-modal'
          onCancel={() => setShowDeleteModal(false)}
          footer={[
            <div className='modal-actions' key='pack-delete-actions'>
              <Button
                className='modal-cancel'
                onClick={() => setShowDeleteModal(false)}
              >
                Annuler
              </Button>
              <Button
                className='modal-delete'
                loading={isLoading}
                onClick={suppPack}
              >
                Supprimer
              </Button>
            </div>,
          ]}
        >
          <div className='delete-warning'>
            <FaExclamationTriangle />
            <div>
              <strong>{selectedPack.nom || 'Pack sélectionné'}</strong>
              <p>
                Cette suppression retire l’offre du catalogue commercial. Vérifiez
                qu’aucun abonnement actif ne dépend de ce pack avant de confirmer.
              </p>
            </div>
          </div>
        </Modal>
      </Container>
    </Layout>
  );
};

const KpiCard = ({ icon, label, value }: { icon: ReactNode; label: string; value: ReactNode }) => (
  <div className='kpi-card'>
    <div>
      <span className='label'>{label}</span>
      <strong className='value'>{value}</strong>
    </div>
    <span className='icon'>{icon}</span>
  </div>
);

const COLUMNS = [
  {
    title: 'NOM DU PACK',
    render: (cell: any, row: PackType) => (
      <div className='pack-cell'>
        <strong>{row.nom}</strong>
        <span>Offre MoranjETrade</span>
      </div>
    ),
    sorter: (a: PackType, b: PackType) => a.nom.localeCompare(b.nom),
  },
  {
    title: 'MONTANT',
    render: (cell: any, row: PackType) => (
      <span className='amount-cell'>
        {Number(row.amount || 0).toLocaleString('fr-FR')} XAF
      </span>
    ),
  },
  {
    title: 'DUREE (ANNEE)',
    render: (cell: any, row: PackType) => (
      <Tag className='duration-tag'>{row.duree_an} an</Tag>
    ),
  },
];
